import React,{useEffect} from "react";
import styles from "../Disclaimer/Disclaimer.module.scss";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { useLocation } from "react-router-dom";

// import Link from "react-router-dom";

const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Disclaimer", link: "/disclaimer" },
];
const DisclaimerSection: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        const yOffset = -100; 
      const yPosition = sectionElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: yPosition, behavior: "smooth" });
        
      }
    }
  }, [location]);

  return (
    <>
      <div className={styles.DisclaimerSection}>
        <BreadCrumb menu={breadcrumb} />
        <div className="container">
          <div className="row" id="disclaimerSection">
            <p className={`${styles.mainhead} heading`}>
              Disclaimer & Terms of Use
            </p>
          </div>
        </div>
        <General />
        <TermsOfUse />
        <PravicyPolicy />
        <ProfanityPolicy />
      </div>
    </>
  );
};

export default DisclaimerSection;

const General: React.FC = () => {
  return (
    <div className={styles.GeneralSection}>
      <div className="container">
        <div className="row">
          <p className={`${styles.subHead} subHeading`}>General disclaimer</p>
          <p className="para">
            The contents, images, pictures, graphics etc. On the site could
            include technical inaccuracies or typographical errors. Correction
            and changes are periodically made to the information herein. Aptech
            may make improvements and/or changes herein at any time at its sole
            discretion without notice. Aptech makes no representations about the
            accuracy of the information contained in the contents, documents and
            graphics on the site for any purpose. All contents, documents and
            graphics are provided "as is". Aptech hereby disclaims all
            warranties and conditions with regard to this information, including
            all implied warranties and conditions of merchantability, fitness
            for any particular purpose, title and non-infringement. In any
            event, aptech shall not be liable to any party for any direct,
            indirect, special or other consequential damages for any use of the
            site, the information, or on any other hyperlinked web site,
            including, without limitation, any loss of profits, business
            interruption, loss of programs or other data on your information
            handling system or otherwise
          </p>
        </div>
      </div>
    </div>
  );
};

const TermsOfUse: React.FC = () => {
  return (
    <div className={styles.TermsOfUseSection}>
      <div className="container">
        <div className="row">
          <p className={`${styles.subHead} subHeading`}>Terms of Use</p>
          <p className="para">
            Your use of Aptech's services and Site (referred to collectively as
            the "Services") is subject to the terms of Use. "Aptech" means
            Aptech Limited, Aptech House, A-65, MIDC, Marol, Andheri (E), Mumbai
            400093, India including its subsidiaries.
          </p>
          <ul className="para">
            <span>
              The following terms and conditions will be deemed to have been
              accepted by the User on visiting and usage of the following
              websites:
            </span>
            <div className={`${styles.termsList} para`}>
              <a
                href="https://www.arena-multimedia.com/in/en"
                target="_blank"
                className={styles.list}
              >
                <li>www.arena-multimedia.com</li>
              </a>
              <a
                href="https://www.arena-multimedia.com/in/en"
                target="_blank"
                className={styles.list}
              >
                <li>m.arena-multimedia.com</li>
              </a>
              <a
                href="https://www.maacindia.com/"
                target="_blank"
                className={styles.list}
              >
                <li>m.maacindia.com</li>
              </a>

              <a
                href="https://www.aptechlearning.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechlearning.com</li>
              </a>
              <a
                href="https://www.aptech-education.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptech-education.com</li>
              </a>
              <a
                href="https://m.aptech-education.com/"
                target="_blank"
                className={styles.list}
              >
                <li>m.aptech-education.com</li>
              </a>
              <a
                href="https://www.aptechaviationacademy.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechaviationacademy.com</li>
              </a>
              <a
                href="http://www.aptechnpower.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechnpower.com</li>
              </a>
              <a
                href="https://www.aptechbankingfinance.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechbankingfinance.com</li>
              </a>
              <a
                href="https://www.englishexpress.in/"
                target="_blank"
                className={styles.list}
              >
                <li>www.englishexpress.in</li>
              </a>
              <a
                href="https://www.lakme-academy.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.lakme-academy.com</li>
              </a>
              <a
                href="https://www.aptechinternationalpreschool.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechinternationalpreschool.com</li>
              </a>
              <a
                href="http://www.aptechglobaltraining.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechglobaltraining.com</li>
              </a>
              <a
                href="http://www.aptechtrainingsolutions.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.aptechtrainingsolutions.com</li>
              </a>
              <a
                href="http://www.attest.co.in/"
                target="_blank"
                className={styles.list}
              >
                <li>www.attest.co.in</li>
              </a>
              <a
                href="https://www.proalley.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.proalley.com</li>
              </a>
              <a
                href="https://thevirtualproductionacademy.com/"
                target="_blank"
                className={styles.list}
              >
                <li>www.thevirtualproductionacademy.com</li>
              </a>
            </div>
          </ul>
        </div>
        <div className="row mt-3">
          <ul className="para">
            <span>
              You are requested to read them carefully before you use the
              services of the site.
            </span>
            <div className={styles.textNote}>
              <li>
                The term User shall refer to the user who is has visited the
                Site and browsing the Site. The terms 'Site' refers to the
                aforementioned websites belonging to Aptech.
              </li>
              <li>
                By using the Site, you agree to follow and be bound by the
                following terms and conditions concerning your use of the Site.
                Aptech may revise the Terms of Use at any time without notice at
                its sole discretion.
              </li>
              <li>
                Aptech may terminate User's access at any time for any reason
                whatsoever. The provisions regarding a disclaimer of warranty,
                accuracy of information and indemnification shall survive such
                termination. Aptech shall continuously monitor access to the
                Site.
              </li>
              <li>
                All content, graphics, images, pictures etc. present on the Site
                is the sole and exclusive property of Aptech. The software,
                text, images, graphics, video and audio used on the Site belong
                to Aptech. No material from this site shall be copied, modified,
                reproduced, republished, uploaded, transmitted, adopted, posted
                or distributed in any form whatsoever. All rights herein are
                reserved. Unauthorized use of the materials appearing on this
                site may violate copyright, trademark and other applicable laws,
                and could result in criminal and/or civil actions. Aptech is a
                registered trademark of Aptech Limited. This trademark shall not
                be used in any manner whatsoever.
              </li>
              <li>
                Aptech does not make any warranties, express or implied,
                including without limitation, those of merchantability and
                fitness for a particular purpose, with respect to any
                information, data, statements, services or products made
                available on the Site.
              </li>
              <li>
                Aptech does not accept any responsibility towards the contents
                and/or information practices of third party Sites which may have
                links through Aptech's Site.
              </li>
              <li>
                The Site, and all content, materials, information, software,
                products and services provided on the Site, are provided on an
                "as is" and "as available" basis. Aptech disclaims all
                warranties of any kind, whether express or implied, including,
                but not limited to, the implied warranties of merchantability,
                fitness for a particular purpose and non-infringement.
              </li>
              <li>
                Aptech has no responsibility for any damage to a User's computer
                system or loss of data that result from the download of any
                content, materials, information from the Site.
              </li>
              <li>
                Aptech may change or discontinue any aspect, portion of the Site
                at any time without notice, including its content or features.
                Aptech reserves the right to change the terms and conditions
                applicable to the use of the Site. Such changes shall be
                effective immediately without notice, which shall be placed on
                the Site.
              </li>
              <li>
                In any event Aptech will not be liable for damages of any kind,
                including without limitation, direct, incidental or
                consequential damages (including, but not limited to, damages
                for loss of profits, business interruption and loss of programs
                or information) arising out of the use of Aptech's Site, or any
                information provided on the Site, or in the Products or
                Services, any claim attributable to errors, omissions or other
                inaccuracies in the Product or interpretations thereof
              </li>
              <li>
                The User agrees to indemnify, defend and hold Aptech harmless
                from and against all losses, expenses, damages and costs,
                including reasonable attorneys' fees, arising out of or relating
                to any misuse by the User of the content and services provided
                on the Site.
              </li>
              <li>
                Aptech disclaims all warranties as to the accuracy, completeness
                or adequacy of information contained in the Site.
              </li>
              <li>
                Aptech makes no warranty (a) that the Site will meet your
                requirements; (b) that the Site will be available on an
                uninterrupted, timely, secure, or error-free basis; (c) that the
                results that may be obtained from the use of the Site or any
                services offered through the Site will be accurate or reliable.
              </li>
              <li>
                Any information provided by the User will not be shared with any
                third party. Aptech reserves the right to use the said
                information.
              </li>
              <li>
                The Site may provide links to Web sites and access to content,
                products and services from third parties, including users,
                advertisers, affiliates and sponsors of the Site. You agree that
                Aptech is not responsible for the availability of, and content
                provided on, third party Web sites. Aptech is not responsible
                for third party content accessible through the Site, including
                opinions, advice, statements and advertisements and User shall
                bear all risks associated with the use of such content. Aptech
                is not responsible for any loss or damage of any sort that a
                User may incur from dealing with any third party.
              </li>
            </div>
          </ul>
        </div>
      </div>
    </div>
  );
};

const PravicyPolicy: React.FC = () => {
  return (
    <div className={styles.PravicyPolicySection} id="privacySection">
      <div className="container">
        <div className="row" id="privacyPolicy">
          <p className={`${styles.mainhead} heading`}>Privacy policy</p>
          <div className="para">
            <span>
              We do not sell or forward or rent your personal information what
              you share with Aptech, to any third party for any purposes like
              marketing etc. without your consent. This privacy policy is
              applicable to our services available under the aforesaid domain
              names. Your use of Aptech Site will signify your acceptance of the
              Aptech Privacy Policy.
            </span>
            <br />
            <span>
              Wherever your Personal Information is held within Aptech, the
              company shall take reasonable steps to protect it from
              unauthorized access or disclosure. Aptech is committed to
              protecting the security of your personal information. We store the
              personal information you provide on computer systems with limited
              access, which are located in controlled facilities. When we
              transmit highly confidential information, we protect it through
              the use of encryption.
            </span>
            <br />
            <span>
              You may choose whether or not to provide Personal Information to
              Aptech. If you choose not to provide the Personal Information then
              you may be unable to access certain options, offers, and services
              that involve our interaction with you. If you chose to have a
              relationship with Aptech, Aptech will continue to contact you in
              connection with that business relationship.
            </span>
            <br />
            <span>
              Where Aptech gets your Personal Information on the Site, Aptech
              intends to explain why Personal Information will be collected and
              whether Aptech plans to share such Personal Information outside or
              with those working on Aptech's behalf. Unless the transfer of
              Personal Information is legally required, Aptech will not transfer
              Personal Information without your permission to third parties.
            </span>
            <br />
            <span>
              In the event that you do provide Personal Information, Aptech
              shall maintain accurate Personal Information that you have
              provided. Where Aptech collects Personal Information from you on
              the Site, its aim is to provide a means of contacting Aptech
              whenever you need to update or correct that Information.
            </span>
            <br />
            <span>
              Personal Information will be kept confidential and will be used
              for our research, marketing, and strategic client analysis
              objectives and other internal business purposes only. We do not
              sell or rent Personal Information, except that your Personal
              Information shall be shared with our business partners/franchisees
              and you shall be deemed to have given consent to the same. We will
              share Personal Information only under the circumstances where we
              are compelled by law (including court orders) to do so.
            </span>
            <br />
            <span>
              By using the Site, you consent to the terms of Aptech’s Privacy
              Policy and processing of Personal Information for the purposes
              given above. When your Personal information is needed, Aptech will
              not be obligated to let you know at the time of collection, how it
              will use the personal information. Generally the personal
              information Aptech collects is used only by it to respond to your
              inquiry, process an order or allow you to access specific
              services. You will be offered an opportunity to limit access to
              your information. In case Aptech does not receive any response
              from you to limit the access of your information, it shall be
              deemed that you consent to such distribution of your Personal
              Information as mentioned above.
            </span>
            <br />
            <span>
              Please note that this Privacy Policy may keep changing from time
              to time without notice at the sole discretion of Aptech. If you
              have any questions about Aptech Privacy Policy, collection, use,
              or disclosure of your personal information, please e-mail us at{" "}
              <a href="" className={styles.emailId}>
                digitalsolutions@aptech.co.in
              </a>
               
            </span>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfanityPolicy: React.FC = () => {
  return (
    <div className={`${styles.ProfanityPolicySection} section`} id="profinitySection">
      <div className="container">
        <div className="row">
          <p className={`${styles.mainhead} heading`}>Profanity Policy</p>
          <p className="para">
            In all your interactions with Aptech staff and employees, we solicit
            that they be treated with courtesy and respect. Aptech is committed
            to a zero tolerance culture towards rude, inappropriate, threatening
            and abusive language or behavior. We also reserve the right to
            pursue appropriate legal action under extreme circumstances.
            <br />
            <br />
            <strong>Help us serve you better!</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
